import { CONTACT_EMAIL, CONTACT_WHATSAPP_URL } from "./contact";

/** @type {string} */
export const BUY_EMAIL_SUBJECT = "I'd like to buy a photo";

export const BUY_EMAIL_HREF = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(BUY_EMAIL_SUBJECT)}`;

/**
 * Product sections — duplicate a block in this array to add a new category.
 * TODO: Confirm all prices before launch.
 *
 * @type {Array<{
 *   number: string,
 *   key: string,
 *   icon: "digital" | "print" | "frame",
 *   title: string,
 *   description: string,
 *   cardGrid: "wide" | "standard",
 *   cards: Array<{ label: string, detail: string, price: string }>,
 *   pricingNote?: string,
 * }>}
 */
export const BUY_PRODUCT_SECTIONS = [
  {
    number: "01",
    key: "digital",
    icon: "digital",
    title: "Digital copy",
    description:
      "A high-resolution file, delivered straight to your inbox. Yours to keep, print yourself, or set as the wallpaper you'll never change. Includes a personal-use licence.",
    cardGrid: "standard",
    cards: [
      {
        label: "FULL RESOLUTION",
        detail: "Max quality, big enough to print large.",
        price: "€30",
      },
    ],
  },
  {
    number: "02",
    key: "print",
    icon: "print",
    title: "Fine-art print",
    description:
      "Printed on heavyweight premium fine-art paper with archival inks — deep blacks, rich tones, built to last decades. Shipped flat or rolled, unframed, ready for your own frame.",
    cardGrid: "standard",
    cards: [
      {
        label: "SMALL",
        detail: "A4 · 21 × 30 cm",
        price: "€27",
      },
      {
        label: "MEDIUM",
        detail: "A3 · 30 × 42 cm",
        price: "€45",
      },
      {
        label: "LARGE",
        detail: "A2 · 42 × 59 cm",
        price: "€68",
      },
    ],
  },
  {
    number: "03",
    key: "frame",
    icon: "frame",
    title: "Framed picture",
    description:
      "The full treatment — your print, mounted and set in a handsome solid-wood frame with museum glass. Arrives ready to hang. All the joy, none of the trip to the framer.",
    cardGrid: "standard",
    cards: [],
    pricingNote:
      "I'd love to put a tidy little price tag here, but framing is more art than arithmetic — size, glass, moulding, and where it's going all change the sum. Rather than guess wrong on a website, drop me a line and I'll quote you properly.",
  },
];

export const BUY_HOW_IT_WORKS = [
  {
    step: "1.",
    title: "Find your photo",
    copy: "Browse the galleries and note the title of the one that won't leave you alone.",
  },
  {
    step: "2.",
    title: "Send a message",
    copy: "Email or WhatsApp me the title and which format & size you'd like.",
  },
  {
    step: "3.",
    title: "I sort the rest",
    copy: "I'll confirm price & shipping, send payment details, and get it on its way.",
  },
];

export { CONTACT_WHATSAPP_URL as BUY_WHATSAPP_HREF };
